import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, OnChanges, Output } from '@angular/core';
import { PlanCategory, PlanSimple } from 'src/app/shared/models/planCategoryModel';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomCurrencyPipe } from 'src/app/shared/pipe/custom-currency.pipe';

export enum OperationType {
  NEW = 'NEW',
  RENEW = 'RENEW',
  UPGRADE = 'UPGRADE',
  UPGRADE_RECURRENCE = 'UPGRADE_RECURRENCE',
  EARLY_RENEW = 'EARLY_RENEW'
}

@Component({
  selector: 'app-modal-plan-selection',
  standalone: true,
  imports: [CommonModule, CustomCurrencyPipe],
  templateUrl: './modal-plan-selection.component.html',
  styleUrls: ['./modal-plan-selection.component.scss']
})
export class ModalPlanSelectionComponent implements OnInit, OnChanges {
  @Input() isVisible = false;
  @Input() categories: PlanCategory[] = [];
  @Input() initialCategoryIndex = 0;
  @Input() operationType: any = OperationType.NEW;
  @Output() close = new EventEmitter<void>();
  @Output() selectPlan = new EventEmitter<string>();

  selectedCategoryIndex = 0;
  expandedPlans: Set<string> = new Set();

  constructor(
    public commonService: CommonService
  ) {}

  ngOnInit() {
    // Seleciona a categoria inicial fornecida
    this.selectedCategoryIndex = this.initialCategoryIndex;
  }

  ngOnChanges() {
    // Atualiza quando o índice inicial mudar
    if (this.isVisible) {
      this.selectedCategoryIndex = this.initialCategoryIndex;
    }
  }

  selectCategory(index: number) {
    this.selectedCategoryIndex = index;
  }

  get selectedCategory(): PlanCategory | null {
    const category = this.categories[this.selectedCategoryIndex] || null;
    if (!category) return null;

    // Retornar todos os planos da categoria
    // O filtro por showOnPortal já foi aplicado no componente que chama o modal
    return category;
  }

  onClose() {
    this.close.emit();
  }

  onSelectPlan(planId: string) {
    this.selectPlan.emit(planId);
  }

  getImageUrl(imageId?: string): string {
    return imageId ? this.commonService.getImageStr(imageId) : 'assets/imagens/default-plan.png';
  }

  toggleBenefits(planId: string, event: Event) {
    event.stopPropagation();
    if (this.expandedPlans.has(planId)) {
      this.expandedPlans.delete(planId);
    } else {
      this.expandedPlans.add(planId);
    }
  }

  isPlanExpanded(planId: string): boolean {
    return this.expandedPlans.has(planId);
  }

  getDiferencialBenefits(plan: any): any[] {
    if (!plan.benefits) return [];
    return plan.benefits
      .filter((b: any) => b.diferential === true && b.isActive)
      .sort((a: any, b: any) => a.order - b.order);
  }

  hasDiferencialBenefits(plan: any): boolean {
    return this.getDiferencialBenefits(plan).length > 0;
  }
}

